<template>
  <div class="statistics">

    <div class="row">
      <div class="key" v-if="status == 20">下单数量:</div>
      <div class="key" v-else-if="status == 21">采购数量:</div>
      <div class="key" v-else-if="22">报价数量:</div>
      <div class="key" v-else>商品数量:</div>
      <div class="val">{{ statistics.c_num }}</div>
    </div>
    <div class="row">
      <div class="key" v-if="!orderPaymen">总价:</div>
      <div class="key" v-else>商品金额:</div>
      <div class="val">{{ statistics.amount.toFixed(2) }}</div>
    </div>


  </div>
</template>
<script>
export default {
  props: {
    checkedList: { type: Array },
    orderPaymen: { type: Boolean },
    status: { type: Number },
  },
  computed: {
    statistics() {

      let total = {
        c_num: 0,
        amount: 0,
      }
      this.checkedList.forEach(item => {
        if (this.orderPaymen) {
          // console.log(item);
          total.c_num += item.possible_num - 0
          total.amount += item.possible_num * item.confirm_price
        } else {
          if (this.status == 20) {
            total.c_num += item.num - 0
            total.amount += (item.num * item.price)
          } else if (this.status == 21) {
            total.c_num += item.confirm_num - 0
            total.amount += (item.confirm_num * item.confirm_price + (item.confirm_freight - 0))
          } else {
            total.c_num += item.offer_num - 0
            total.amount += (item.offer_num * item.offer_price + (item.offer_freight - 0))
          }
        }
      })
      return total
    }
  },
  data() {
    return {

    };
  },
  methods: {

  }
}
</script>
<style lang='scss' scoped>
.row {
  display: flex;
  margin-bottom: 5px;
  color: #000;

  .key {
    width: 60px;
    margin-right: 10px
  }

  .val {
    color: #B4272D;
  }
}

/deep/.el-popover {
  background-color: pink !important;
}
</style>